import { render, staticRenderFns } from "./marketDetail.vue?vue&type=template&id=11df9ebb&scoped=true&lang=pug&"
import script from "./marketDetail.vue?vue&type=script&lang=js&"
export * from "./marketDetail.vue?vue&type=script&lang=js&"
import style0 from "./marketDetail.vue?vue&type=style&index=0&id=11df9ebb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df9ebb",
  null
  
)

export default component.exports